import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SuccessAsidePanelComponent } from "./success-aside-panel.component";
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';

@NgModule({
    imports: [
        SvgIconModule,
        CommonModule,
        RouterModule,
    ],
    declarations: [
        SuccessAsidePanelComponent
    ],
    exports: [
        SuccessAsidePanelComponent
    ],
    entryComponents: [
        SuccessAsidePanelComponent
    ]
})
export class SuccessAsidePanelModule {}